// extracted by mini-css-extract-plugin
export default {"creditItem":"style_creditItem__gtBGZ","redImgCredit":"style_redImgCredit__oeErF","redCreditImage":"style_redCreditImage__VzG5E","creditInfoTitle":"style_creditInfoTitle__MajdF"};